import { BlotterSettingsProvider } from '@src/components/Blotters/BlotterSettingsContext';
import {
  BlotterTableContextProvider,
  BlotterTableStorageProvider,
  CustomThemeContextProvider,
  CustomerDepositWithdrawProvider,
  GlobalCancelDialogProvider,
  MarketDataCardsProvider,
  OMSStateProvider,
  ProvidersGate,
  QuotesProvider,
  RecentSymbolsProvider,
  RefRateContextProvider,
  SparklineProvider,
  StrategiesProvider,
  ThemeProvider,
  WLIntlProvider,
  WatchlistSettingsContextProvider,
  WhitelabelOrderFormProvider,
} from '@src/providers';
import {
  AccordionGroup,
  AppwideDrawerProviderWithLocalGuideState,
  BalanceTransactionsProvider,
  CurrenciesProvider,
  CurrencyConversionProvider,
  EndpointsContextProvider,
  GlobalDialogProvider,
  HeartbeatsProvider,
  MarketPriceContextProvider,
  MixpanelProvider,
  NotesProvider,
  RFQServiceProvider,
  SecuritiesProvider,
  WLBalancesProvider,
  WLCustomerMarketAccountsProvider,
  WLCustomerUserConfigContextProvider,
  WLExposuresProvider,
  WLFavoriteSecuritiesProvider,
  WLHomeCurrencyProvider,
  WLOrderServiceProvider,
  WLOrdersProvider,
  WLOrgConfigProvider,
  WLTradingLimitsProvider,
  WLUserContextProvider,
  WLUsersContextProvider,
  WLWebSocketClientProvider,
  composeComponents,
} from '@talos/kyoko';

export const EssentialProviders = composeComponents([
  CustomThemeContextProvider,
  MixpanelProvider,
  WLOrgConfigProvider,
  EndpointsContextProvider,
  WLWebSocketClientProvider,
  WLUserContextProvider,
  WLCustomerMarketAccountsProvider,
  WLIntlProvider,
]);

export const Providers = composeComponents([
  WLCustomerUserConfigContextProvider,
  NotesProvider,
  RecentSymbolsProvider,
  CurrenciesProvider,
  SecuritiesProvider,
  StrategiesProvider,
  WLBalancesProvider,
  WLOrdersProvider,
  QuotesProvider,
  WLHomeCurrencyProvider,
  WLUsersContextProvider,
  CurrencyConversionProvider,
  BlotterTableStorageProvider,
  BlotterTableContextProvider,
  WLExposuresProvider,
  CustomerDepositWithdrawProvider,
  WLTradingLimitsProvider,
  BalanceTransactionsProvider,
  ProvidersGate,
  GlobalDialogProvider,
  WatchlistSettingsContextProvider,
  WLFavoriteSecuritiesProvider,
  RefRateContextProvider,
  MarketPriceContextProvider,
  SparklineProvider,
  AccordionGroup,
  HeartbeatsProvider,

  // Theme
  ThemeProvider,

  // Providers requiring theme
  WhitelabelOrderFormProvider,
  OMSStateProvider,
  WLOrderServiceProvider,
  RFQServiceProvider,
  GlobalCancelDialogProvider,
  AppwideDrawerProviderWithLocalGuideState,
]);

// These Providers are used in Whitelabel Cypress Tests
export const CypressTestProviders = composeComponents([
  CustomThemeContextProvider,
  NotesProvider,
  WLOrgConfigProvider,
  EndpointsContextProvider,
  WLWebSocketClientProvider,
  WLUserContextProvider,
  WLCustomerMarketAccountsProvider,
  WLCustomerUserConfigContextProvider,
  WLIntlProvider,
  CurrenciesProvider,
  SecuritiesProvider,
  StrategiesProvider,
  WLBalancesProvider,
  QuotesProvider,
  WLOrdersProvider,
  WLHomeCurrencyProvider,
  WLUsersContextProvider,
  CurrencyConversionProvider,
  BlotterTableStorageProvider,
  BlotterTableContextProvider,
  WLExposuresProvider,
  WLTradingLimitsProvider,
  ProvidersGate,
  BalanceTransactionsProvider,
  GlobalDialogProvider,
  MarketDataCardsProvider,
  CustomerDepositWithdrawProvider,
  AccordionGroup,
  HeartbeatsProvider,

  ThemeProvider,

  WhitelabelOrderFormProvider,
  OMSStateProvider,
  WLOrderServiceProvider,
  RFQServiceProvider,
  GlobalCancelDialogProvider,
  AppwideDrawerProviderWithLocalGuideState,
  BlotterSettingsProvider,
]);
